import React from 'react';
import { Text, RichText, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { InfoCards as InfoCardsNPM } from '@rotaryintl/component-account-hero';
import { createLink } from '../../utilities/link-helpers';

const HomeAuthenticatedHeroInfoCards = ({ fields: { InfoCards } = {} }) => (
  <InfoCardsNPM
    cards={InfoCards?.map(({ fields: { Title, Description, Link, LinkText, ShowExternalLinkIcon } = {} }) => ({
      title: <Text field={Title} />,
      description: <RichText field={Description} />,
      link: createLink(Link, LinkText, ShowExternalLinkIcon),
    }))}
  />
);

export default withSitecoreContext()(HomeAuthenticatedHeroInfoCards);